const getIteration = (key: string): number => {
  if (key === 'ArrowLeft') {
    return -1;
  }
  if (key === 'ArrowRight') {
    return 1;
  }
  return 0;
};

export const getNextKeyVal = ({
  key,
  currentIndex,
  totalImages,
}: {
  key: string;
  currentIndex: number;
  totalImages: number;
}): number => {
  const iteration = getIteration(key);
  const newTotal = currentIndex + totalImages + iteration;
  return newTotal % totalImages;
};
